"use client";

import { Suspense } from "react";
import { Analytics } from "@vercel/analytics/next";
import { SpeedInsights } from "@vercel/speed-insights/next";

// Both call useSearchParams() internally. During prerender that requires a
// Suspense boundary above them; without one the SSR HTML carries an
// empty-digest error boundary that fails React hydration (#418) on static
// public pages.
export function VercelBeacons() {
  return (
    <Suspense fallback={null}>
      <Analytics />
      <SpeedInsights />
    </Suspense>
  );
}
